import { Product, ProductCategoryValidity, Timeslot } from '~types/appsync.types';
import { Participant } from '~types/participant';

import {
  AGE_URL_PARAM,
  DATE_URL_PARAM,
  PARTICIPANTS_URL_PARAM,
  PRODUCT_CATEGORY_URL_PARAM,
  VALIDITY_CATEGORY_URL_PARAM,
} from '../constants/UrlParams';

interface SelectorDisabledStateParams {
  validityCategory?: ProductCategoryValidity;
  selectedProduct?: Product;
  isLoading: boolean;
  productLocked: boolean;
  date?: Date;
  participants: Participant[];
  selectedTimeslot?: Timeslot;
}

export interface SelectorDisabledState {
  isDateDisabled: boolean;
  isParticipantsDisabled: boolean;
}

export const computeSelectorDisabledStates = ({
  validityCategory,
  selectedProduct,
  isLoading,
  productLocked,
  date,
  participants,
  selectedTimeslot,
}: SelectorDisabledStateParams): SelectorDisabledState => {
  const noProductForValidity = !!validityCategory && !selectedProduct && !isLoading;
  const isDateDisabled =
    (!validityCategory && !date) || (productLocked && !!selectedProduct) || noProductForValidity;
  const hasParticipants = participants.length > 0;
  const prerequisitesMissing =
    !validityCategory || (!date && selectedProduct?.calendarDisplay) || noProductForValidity;
  const bookingPrereqMissing = !!selectedProduct?.isBooking && !selectedTimeslot;
  const isParticipantsDisabled = !hasParticipants && (prerequisitesMissing || bookingPrereqMissing);

  return { isDateDisabled, isParticipantsDisabled };
};

/** Selection-related URL params that indicate the drawer should auto-open */
const SELECTION_URL_PARAMS = [
  PRODUCT_CATEGORY_URL_PARAM,
  VALIDITY_CATEGORY_URL_PARAM,
  DATE_URL_PARAM,
  AGE_URL_PARAM,
  PARTICIPANTS_URL_PARAM,
];

/**
 * Returns true when the current URL contains at least one selection parameter,
 * indicating the purchase drawer should open automatically on page load.
 */
export const hasSelectionInUrl = (): boolean => {
  const searchParams = new URL(globalThis.location.href).searchParams;
  return SELECTION_URL_PARAMS.some((param) => searchParams.has(param));
};
